import './styles.scss';

export const SolutionCard = ({ image, numbers, description, index }) => {
    return (
        <div className={`solution-card solution-card--${index + 1}`}>
            <img src={image} alt={image} />
            <div className="solution-card__title">{numbers}</div>
            <p className="body1">{description}</p>
        </div>
    );
};
